var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 3.5C30.6775 3.5 38.5 11.3225 38.5 21C38.5 30.6775 30.6775 38.5 21 38.5C11.3225 38.5 3.5 30.6775 3.5 21C3.5 11.3225 11.3225 3.5 21 3.5ZM27.2825 12.25L21 18.5325L14.7175 12.25L12.25 14.7175L18.5325 21L12.25 27.2825L14.7175 29.75L21 23.4675L27.2825 29.75L29.75 27.2825L23.4675 21L29.75 14.7175L27.2825 12.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCancel);
export default __webpack_public_path__ + "static/media/NewCancel.f91ce8079f0945657d55b5ba08c364ec.svg";
export { ForwardRef as ReactComponent };